module.exports = __webpack_public_path__ + "static/media/aceptacionPlazoFijo.d2b91be5.svg";